export class Modality {
	constructor(
		public sigla: string,
		public name: string
	) {
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-other-banks/models/modality.ts